import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, map, of } from 'rxjs';
import { ValveStatusApiService } from '../services/valve-status-api.service';
import { TimezoneService } from 'src/app/services/utility/timezone.service';
import { ValveStatusActions } from './valve-status.actions';
import { RemoteConnDisconn } from './valve-status.state';
import { mapOperationTypeToPayload, mapResponseToRemoteConnDisconn } from './valve-status.mappers';

export const setValveStatus = createEffect(
  (actions$ = inject(Actions), valveStatusApiService = inject(ValveStatusApiService)) =>
    actions$.pipe(
      ofType(ValveStatusActions.setValveStatus),
      concatMap(({ deviceUID, operationType }) =>
        valveStatusApiService.postValveStatus(deviceUID, mapOperationTypeToPayload(operationType)).pipe(
          map(() => ValveStatusActions.getValveStatus({ deviceUID })),
          catchError(() => of(ValveStatusActions.getValveStatus({ deviceUID })))
        )
      )
    ),
  { functional: true }
);

export const getValveStatus = createEffect(
  (
    actions$ = inject(Actions),
    valveStatusApiService = inject(ValveStatusApiService),
    timezoneService = inject(TimezoneService)
  ) =>
    actions$.pipe(
      ofType(ValveStatusActions.getValveStatus),
      concatMap(({ deviceUID }) =>
        valveStatusApiService.getValveStatus(deviceUID).pipe(
          map(valveStatusResponse =>
            valveStatusResponse
              ? ValveStatusActions.getValveStatusSuccess({
                  deviceUID,
                  valveStatusResponse: {
                    ...valveStatusResponse,
                    remoteConnDisconn: mapResponseToRemoteConnDisconn(valveStatusResponse.remoteConnDisconn),
                    updatedOnUTC: valveStatusResponse.updatedOnUTC
                      ? timezoneService.formatLong(valveStatusResponse.updatedOnUTC)
                      : null
                  }
                })
              : ValveStatusActions.getValveStatusSuccess({
                  deviceUID,
                  valveStatusResponse: {
                    requestType: null,
                    requestStatus: null,
                    remoteConnDisconn: RemoteConnDisconn.NoData,
                    updatedOnUTC: null
                  }
                })
          ),
          catchError((error: unknown) =>
            of(
              ValveStatusActions.getValveStatusFailure({
                error: error instanceof Error ? error.message : 'Unknown error'
              })
            )
          )
        )
      )
    ),
  { functional: true }
);
